import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Trans } from 'react-i18next';

import { Text } from '../../atoms/text';

class Renderer extends React.Component {
  render() {
    return (
      <React.Fragment>
        <span className="widget-notification-nav__all-read" onClick={this.props.readAllNotifications}>
          <Text color="#b0bec5" size={12}>
            <Trans>Mark all as read</Trans>
          </Text>
        </span>

        <Link to="/settings/notifications" className="widget-notification-nav__settings">
          <Text color="#00b0ff" size={12}>
            <Trans>Notifications Settings</Trans>
          </Text>
        </Link>
      </React.Fragment>
    );
  }
}

const mapState = () => ({});

const mapDispatch = (dispatch, props) => ({
  readAllNotifications: async () => {
    if (await window.confirm('Are you sure you want to mark all notifications as read?')) {
      dispatch.notifications.readAllAsync();
    }
  },
});

export const NotificationsNav = connect(mapState, mapDispatch)(Renderer);
